import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (zone) =>
    present(
      repository
        .getZoneResources(zone)
        .then((resources) => ({ zone, resources })),
    );
}

export type { Interactor };

export { createInteractor };
